<template>
    <button @click="player.showOptions = true"
            :class="{'pp-ui-button': applyStyles, 'pp-ui-button-options': applyStyles}">
        <slot>
            <Icon/>
        </slot>
    </button>
</template>

<script>
  import {PPComponentMixin} from "../mixins";
  import Icon from '../style/assets/options.svg';

  export default {
    name: "PPButtonOptions",
    mixins: [PPComponentMixin],
    components: {Icon}
  }
</script>
